<script lang="ts">
	import type { Snippet } from 'svelte';
	import { VpIcon } from '@vtmn-play/svelte/VpIcon';

	interface Props {
		variant?: 'single-choice' | 'input' | 'filter' | 'action';
		size?: 'small' | 'medium';
		selected?: boolean;
		disabled?: boolean;
		iconLeft?: string;
		iconLeftSize?: number;
		iconLeftClass?: string;
		iconRight?: string;
		imageSrc?: string;
		imageRightSrc?: string;
		imageRightClass?: string;
		style?: string;
		class?: string;
		closeButtonAction?: () => void;
		onclick?: (e: MouseEvent) => void;
		children?: Snippet;
	}

	let {
		variant = 'filter',
		size = 'medium',
		selected = false,
		disabled = false,
		iconLeft = undefined,
		iconLeftSize = 0,
		iconLeftClass = '',
		iconRight = undefined,
		imageSrc = undefined,
		imageRightSrc = undefined,
		imageRightClass = '',
		style = undefined,
		class: className = '',
		closeButtonAction,
		onclick,
		children
	}: Props = $props();
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<div
	class="vtmn-chip {className}"
	class:vtmn-chip_variant--single-choice={variant === 'single-choice'}
	class:vtmn-chip_variant--input={variant === 'input'}
	class:vtmn-chip_variant--filter={variant === 'filter'}
	class:vtmn-chip_variant--action={variant === 'action'}
	class:vtmn-chip_size--small={size === 'small'}
	class:vtmn-chip_size--medium={size === 'medium'}
	{style}
	role="button"
	tabindex={disabled ? -1 : 0}
	aria-pressed={selected}
	aria-disabled={disabled}
	{onclick}
>
	{#if imageSrc}
		<img src={imageSrc} alt="chip-thumbnail" />
	{/if}

	{#if iconLeft}
		<VpIcon class={iconLeftClass} size={iconLeftSize} name={iconLeft} aria-hidden="true" />
	{/if}

	{@render children?.()}

	{#if variant === 'input'}
		<button
			class="vtmn-btn vtmn-btn--icon-alone vtmn-btn_size--{size} vtmn-btn_variant--ghost vtmn-text-content-primary"
			{disabled}
			onclick={() => closeButtonAction?.()}
		>
			<span class="vtmn-sr-only">Unselect this chip</span>
			<span class="vtmx-close-line" aria-hidden="true" />
		</button>
	{/if}

	{#if iconRight}
		<span class={iconRight} aria-hidden="true" />
	{/if}

	{#if imageRightSrc}
		<img
			class="{imageRightClass} vtmn-pb-1 vtmn-pl-1"
			src={imageRightSrc}
			alt="chip-thumbnail-right"
			data-testId="imageRight"
		/>
	{/if}
</div>
